// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: lato, sans-serif;
  font-size: 14px;
  color: #212121;
  width: 100%;
  height: 100%;
  background-color: #1172a3;
  margin: 0;
  padding: 0;
}
h2 {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
  color: #1172a3;
  font-size: 24px;
  margin-top: 0;
}
h3 {
  font-size: 16px;
}
.headerWithLinks {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: flex-start;
}
.headerWithLinks span {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 20px;
}
.headerWithLinks span img {
  margin-right: 5px;
}
.blueBg {
  background-color: #1172a3;
}
#app {
  width: 100%;
  max-width: 1440px;
}
.section {
  padding: 50px 0;
}
.main {
  width: 100%;
  background-color: #fff;
}
.wrapper {
  box-sizing: border-box;
  width: 100%;
  padding: 0 40px;
}

.pageTitle {
  position: absolute;
  bottom: 1px;
  left: 40px;
}
.pageTitle img {
  height: 50px;
}
.sticky {
  position: sticky;
}
.hero {
  position: relative;
}
.hero img {
  width: 100%;
  padding: 0;
  margin: 0;
}

. h1.title {
  text-align: center;
  font-family: georgia;
  font-size: 36px;
  color: #17acc0;
  width: 100%;
}

.carousel {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.carousel h3 {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  justify-content: left;
  align-items: left;
  font-family: lato, sans-serif;
  font-weight: 600;
  font-style: normal;
  color: #212121;
  font-size: 16px;
  margin: 0 10px 5px 10px;
}

.carousel .border,
.dashedLine {
  border-top: 1px dashed #999999;
  width: 100%;
  height: 1px;
}
.carousel .books {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  height: 50px;
  align-items: center;
  justify-content: flex-start;

  margin: 0 20px;
  font-size: 14px;
}
.carousel div {
  margin: 10px 20px;
}

.sortMenu {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.sortMenu label {
  flex: 0 0 auto;
  margin-left: auto;
  margin-right: 5px;
  font-family: Helvetica;
  font-size: 14px;
}

.sortMenu select {
  -webkit-appearance: none;
  border: 1px solid #999;
  padding: 5px 40px 5px 5px;
  background-color: #fff;
  border-radius: 5px;
  font-size: 14px;
  background-image: url("/arrowDown.png");
  background-position: top 8px right 6px;
  background-repeat: no-repeat;
  background-size: 12px;
}

.twoCol {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  box-sizing: border-box;
}
.twoCol .gutter {
  width: 40px;
}
.filter {
  flex: 0 0 auto;
  box-sizing: border-box;
  margin-right: 50px;
}

.filter label a {
  font-family: lato, sans-serif;
  font-weight: bold;
  font-style: normal;
  color: #212121;
  font-style: normal;
  text-decoration: none;
  font-size: 16px;
  background-image: url("/arrowUp.png");
  background-position: top 8px right 0;
  padding-right: 20px;
  background-repeat: no-repeat;
  background-size: 12px;
}
.filter label a.open {
  background-image: url("/arrowDown.png");
}
.filter ul {
  list-style: none;
  margin: 0;
  padding: 10px 0 0 0;
  font-family: lato, sans-serif;
  font-size: 16px;
  color: #333;
}
.filter ul li {
  padding-bottom: 10px;
}
.filter ul li input[type="checkbox"] {
  margin: 0 5px 0 0;
  padding: 0;
}

a,
a:active,
a:visited {
  color: #1172a3;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

.space10 {
  height: 10px;
}
.space20 {
  height: 20px;
}
.space40 {
  height: 40px;
}
.space60 {
  height: 60px;
}
.space80 {
  height: 80px;
}

.lightBox {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
}

.bookDetails {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  justify-content: center;
  max-width: 500px;
  margin-top: 100px;
}

.bookDetails h3 {
  color: #17acc0;
  font-size: 30px;
  font-weight: bold;
  margin: 0 0 10px 0;
  font-family: balto;
}
.bookDetails .cover {
  flex: 0 0 auto;
  margin-right: 50px;
}
.bookDetails .summary {
  flex: 1 1 auto;
}
.bookDetails .summary p {
  margin: 0 0 10px 0;
}
.close img {
  width: 30px;
  margin-top: 30px;
}
.buttonBlue,
.cancelButton {
  color: #fff;
  font-family: lato, sans-serif;
  font-weight: bold;
  font-size: 14px;
  border: 1px solid #fff;
  border-radius: 25px;
  padding: 10px 20px;
  margin-right: 10px;
}
.buttonBlue {
  background-color: #1172a3;
}
.cancelButton {
  background-color: #bd3913;
}
.lightBox .buttonBlue {
  margin-top: 20px;
}
.tableButton {
  text-align: right;
}
#genreList,
#collectionList {
  display: none;
}
#genreList.open,
#collectionList.open {
  display: block;
}
ul.checkList {
  display: flex;
  flex-flow: row wrap;
  font-family: lato, sans-serif;
  font-size: 16px;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  list-style: none;
  margin: 0;
  padding: 0;
  margin-bottom: 32px;
}
ul.checkList li {
  margin-right: 20px;
  margin-bottom: 20px;
  width: 200px;
}
ul.checkList li,
#collectionList.open li,
#genreList.open li {
  display: flex;
  flex-flow: row;
  align-items: center;
}

#contextMenu {
  position: fixed;
  border: 1px solid #17acc0;
  background-color: #fafafa;
  line-height: 2em;
  left: 0px;
  top: 0px;
  display: none;
}
#contextMenu ul {
  margin: 0;
  padding: 0;
}
#contextMenu li {
  list-style: none;
  padding: 5px 30px;
}
#contextMenu a,
#contextMenu a:visited,
#contextMenu a:hover,
#contextMenu a:active {
  text-decoration: none;
  color: #17acc0;
}
#contextMenu ul li:hover {
  background-color: #17acc0;
}
#contextMenu ul li:hover a:visited,
#contextMenu ul li:hover a:hover,
#contextMenu ul li:hover a:active {
  background-color: #17acc0;
  color: #fff;
}
.bookLinkBox {
  width: 100%;

  box-sizing: border-box;
  height: 200px;
  overflow-y: scroll;
  overflow-x: hidden;
  background: #ffffff;
  border: 2px solid #cccccc;
  border-radius: 5px;
}
.bookLinkBox ul {
  display: flex;
  flex-flow: column wrap;
  align-items: left;
  width: 100%;
  height: 200px;
  list-style: none;
  padding: 0;
  box-sizing: border-box;
}
.bookLinkBox ul li {
  max-width: 200px;
  padding: 10px 20px;
}
.subTitleBar {
  display: flex;

  padding: 0 20px 0 20px;
  width: 100%;
  flex-flow: row;
  align-items: stretch;
  box-sizing: border-box;
}
.subTitleBar h3 {
  flex: 1 1 auto;
  font-size: 18px;
  font-weight: bold;
  margin: 10px 0;
}
.subTitleBar .links {
  margin-left: auto;
}
.booksToSwap {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;

  padding: 0 60px;
}
.booksToSwap #bookToOffer,
.booksToSwap #bookToReceive {
  flex: 0 0 auto;
}
.booksToSwap #bookToOffer img,
.booksToSwap #bookToReceive img {
  width: 100%;
  max-width: 175px;
}
.booksToSwap .swapImg {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 100%;
  max-height: 272px;
}
.booksToSwap .swapImg img {
  position: absolute;
  max-width: 90px;
  text-align: center;
  height: 100%;
}
.checkboxWrapper {
  position: relative;
  align-items: center;
  width: 16px;
  height: 16px;
  border: 1px solid #999;
  border-radius: 25%;
  margin-right: 5px;
}
.checkboxWrapper .checkbox {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 16px;
  height: 16px;
  border-radius: 25%;
  border: 1px solid #fff;
  box-sizing: border-box;
  background-color: #fff;
}

.checkboxWrapper .checkbox.checked {
  background-color: #00aeef;
}
.checkboxWrapper input[type="checkbox"] {
  visibility: hidden;
  position: absolute;
}
.visuallyHidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
.ctaLink {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.ctaLink img {
  width: 10px;
  margin-right: 4px;
  margin-left: 20px;
}
.ctaLink span {
  font-size: 14px;
  font-weight: bold;
}
.ctaLink span {
  padding: 0;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./css/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,8BAA8B;EAC9B,WAAW;EACX,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;;EAE3B,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uCAAuC;EACvC,sCAAsC;EACtC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,qCAAqC;EACrC,oCAAoC;EACpC,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,WAAW;AACb;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;;;EAGE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,QAAQ;EACR,aAAa;AACf;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;EAIE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,WAAW;;EAEX,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;;EAEb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;;EAEtB,eAAe;AACjB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,SAAS;AACX","sourcesContent":["body {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-family: lato, sans-serif;\n  font-size: 14px;\n  color: #212121;\n  width: 100%;\n  height: 100%;\n  background-color: #1172a3;\n  margin: 0;\n  padding: 0;\n}\nh2 {\n  font-family: poppins, sans-serif;\n  font-weight: 700;\n  font-style: normal;\n  color: #1172a3;\n  font-size: 24px;\n  margin-top: 0;\n}\nh3 {\n  font-size: 16px;\n}\n.headerWithLinks {\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n.headerWithLinks span {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-left: 20px;\n}\n.headerWithLinks span img {\n  margin-right: 5px;\n}\n.blueBg {\n  background-color: #1172a3;\n}\n#app {\n  width: 100%;\n  max-width: 1440px;\n}\n.section {\n  padding: 50px 0;\n}\n.main {\n  width: 100%;\n  background-color: #fff;\n}\n.wrapper {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 40px;\n}\n\n.pageTitle {\n  position: absolute;\n  bottom: 1px;\n  left: 40px;\n}\n.pageTitle img {\n  height: 50px;\n}\n.sticky {\n  position: sticky;\n}\n.hero {\n  position: relative;\n}\n.hero img {\n  width: 100%;\n  padding: 0;\n  margin: 0;\n}\n\n. h1.title {\n  text-align: center;\n  font-family: georgia;\n  font-size: 36px;\n  color: #17acc0;\n  width: 100%;\n}\n\n.carousel {\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n.carousel h3 {\n  display: flex;\n  flex-flow: row nowrap;\n  width: 100%;\n  justify-content: left;\n  align-items: left;\n  font-family: lato, sans-serif;\n  font-weight: 600;\n  font-style: normal;\n  color: #212121;\n  font-size: 16px;\n  margin: 0 10px 5px 10px;\n}\n\n.carousel .border,\n.dashedLine {\n  border-top: 1px dashed #999999;\n  width: 100%;\n  height: 1px;\n}\n.carousel .books {\n  display: flex;\n  flex-flow: row nowrap;\n  width: 100%;\n  height: 50px;\n  align-items: center;\n  justify-content: flex-start;\n\n  margin: 0 20px;\n  font-size: 14px;\n}\n.carousel div {\n  margin: 10px 20px;\n}\n\n.sortMenu {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n}\n.sortMenu label {\n  flex: 0 0 auto;\n  margin-left: auto;\n  margin-right: 5px;\n  font-family: Helvetica;\n  font-size: 14px;\n}\n\n.sortMenu select {\n  -webkit-appearance: none;\n  border: 1px solid #999;\n  padding: 5px 40px 5px 5px;\n  background-color: #fff;\n  border-radius: 5px;\n  font-size: 14px;\n  background-image: url(\"/arrowDown.png\");\n  background-position: top 8px right 6px;\n  background-repeat: no-repeat;\n  background-size: 12px;\n}\n\n.twoCol {\n  display: flex;\n  flex-flow: row nowrap;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: space-between;\n  box-sizing: border-box;\n}\n.twoCol .gutter {\n  width: 40px;\n}\n.filter {\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  margin-right: 50px;\n}\n\n.filter label a {\n  font-family: lato, sans-serif;\n  font-weight: bold;\n  font-style: normal;\n  color: #212121;\n  font-style: normal;\n  text-decoration: none;\n  font-size: 16px;\n  background-image: url(\"/arrowUp.png\");\n  background-position: top 8px right 0;\n  padding-right: 20px;\n  background-repeat: no-repeat;\n  background-size: 12px;\n}\n.filter label a.open {\n  background-image: url(\"/arrowDown.png\");\n}\n.filter ul {\n  list-style: none;\n  margin: 0;\n  padding: 10px 0 0 0;\n  font-family: lato, sans-serif;\n  font-size: 16px;\n  color: #333;\n}\n.filter ul li {\n  padding-bottom: 10px;\n}\n.filter ul li input[type=\"checkbox\"] {\n  margin: 0 5px 0 0;\n  padding: 0;\n}\n\na,\na:active,\na:visited {\n  color: #1172a3;\n  text-decoration: none;\n}\na:hover {\n  text-decoration: underline;\n}\n\n.space10 {\n  height: 10px;\n}\n.space20 {\n  height: 20px;\n}\n.space40 {\n  height: 40px;\n}\n.space60 {\n  height: 60px;\n}\n.space80 {\n  height: 80px;\n}\n\n.lightBox {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: rgba(255, 255, 255, 0.8);\n  backdrop-filter: blur(4px);\n}\n\n.bookDetails {\n  display: flex;\n  flex-flow: row nowrap;\n  width: 100%;\n  justify-content: center;\n  max-width: 500px;\n  margin-top: 100px;\n}\n\n.bookDetails h3 {\n  color: #17acc0;\n  font-size: 30px;\n  font-weight: bold;\n  margin: 0 0 10px 0;\n  font-family: balto;\n}\n.bookDetails .cover {\n  flex: 0 0 auto;\n  margin-right: 50px;\n}\n.bookDetails .summary {\n  flex: 1 1 auto;\n}\n.bookDetails .summary p {\n  margin: 0 0 10px 0;\n}\n.close img {\n  width: 30px;\n  margin-top: 30px;\n}\n.buttonBlue,\n.cancelButton {\n  color: #fff;\n  font-family: lato, sans-serif;\n  font-weight: bold;\n  font-size: 14px;\n  border: 1px solid #fff;\n  border-radius: 25px;\n  padding: 10px 20px;\n  margin-right: 10px;\n}\n.buttonBlue {\n  background-color: #1172a3;\n}\n.cancelButton {\n  background-color: #bd3913;\n}\n.lightBox .buttonBlue {\n  margin-top: 20px;\n}\n.tableButton {\n  text-align: right;\n}\n#genreList,\n#collectionList {\n  display: none;\n}\n#genreList.open,\n#collectionList.open {\n  display: block;\n}\nul.checkList {\n  display: flex;\n  flex-flow: row wrap;\n  font-family: lato, sans-serif;\n  font-size: 16px;\n  width: 100%;\n  align-items: flex-start;\n  justify-content: flex-start;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  margin-bottom: 32px;\n}\nul.checkList li {\n  margin-right: 20px;\n  margin-bottom: 20px;\n  width: 200px;\n}\nul.checkList li,\n#collectionList.open li,\n#genreList.open li {\n  display: flex;\n  flex-flow: row;\n  align-items: center;\n}\n\n#contextMenu {\n  position: fixed;\n  border: 1px solid #17acc0;\n  background-color: #fafafa;\n  line-height: 2em;\n  left: 0px;\n  top: 0px;\n  display: none;\n}\n#contextMenu ul {\n  margin: 0;\n  padding: 0;\n}\n#contextMenu li {\n  list-style: none;\n  padding: 5px 30px;\n}\n#contextMenu a,\n#contextMenu a:visited,\n#contextMenu a:hover,\n#contextMenu a:active {\n  text-decoration: none;\n  color: #17acc0;\n}\n#contextMenu ul li:hover {\n  background-color: #17acc0;\n}\n#contextMenu ul li:hover a:visited,\n#contextMenu ul li:hover a:hover,\n#contextMenu ul li:hover a:active {\n  background-color: #17acc0;\n  color: #fff;\n}\n.bookLinkBox {\n  width: 100%;\n\n  box-sizing: border-box;\n  height: 200px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  background: #ffffff;\n  border: 2px solid #cccccc;\n  border-radius: 5px;\n}\n.bookLinkBox ul {\n  display: flex;\n  flex-flow: column wrap;\n  align-items: left;\n  width: 100%;\n  height: 200px;\n  list-style: none;\n  padding: 0;\n  box-sizing: border-box;\n}\n.bookLinkBox ul li {\n  max-width: 200px;\n  padding: 10px 20px;\n}\n.subTitleBar {\n  display: flex;\n\n  padding: 0 20px 0 20px;\n  width: 100%;\n  flex-flow: row;\n  align-items: stretch;\n  box-sizing: border-box;\n}\n.subTitleBar h3 {\n  flex: 1 1 auto;\n  font-size: 18px;\n  font-weight: bold;\n  margin: 10px 0;\n}\n.subTitleBar .links {\n  margin-left: auto;\n}\n.booksToSwap {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  box-sizing: border-box;\n\n  padding: 0 60px;\n}\n.booksToSwap #bookToOffer,\n.booksToSwap #bookToReceive {\n  flex: 0 0 auto;\n}\n.booksToSwap #bookToOffer img,\n.booksToSwap #bookToReceive img {\n  width: 100%;\n  max-width: 175px;\n}\n.booksToSwap .swapImg {\n  position: relative;\n  flex: 1 1 auto;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  max-height: 272px;\n}\n.booksToSwap .swapImg img {\n  position: absolute;\n  max-width: 90px;\n  text-align: center;\n  height: 100%;\n}\n.checkboxWrapper {\n  position: relative;\n  align-items: center;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #999;\n  border-radius: 25%;\n  margin-right: 5px;\n}\n.checkboxWrapper .checkbox {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 16px;\n  height: 16px;\n  border-radius: 25%;\n  border: 1px solid #fff;\n  box-sizing: border-box;\n  background-color: #fff;\n}\n\n.checkboxWrapper .checkbox.checked {\n  background-color: #00aeef;\n}\n.checkboxWrapper input[type=\"checkbox\"] {\n  visibility: hidden;\n  position: absolute;\n}\n.visuallyHidden {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n.ctaLink {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n.ctaLink img {\n  width: 10px;\n  margin-right: 4px;\n  margin-left: 20px;\n}\n.ctaLink span {\n  font-size: 14px;\n  font-weight: bold;\n}\n.ctaLink span {\n  padding: 0;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
